import { AlertNotify } from "../../../components/alerts/AlertNotify";
import { DocumentoPOST } from "../../../models/modules/Cliente/Documento";
import { apiTravel } from "../travel";

export function postDocumentoCliente(data: DocumentoPOST): Promise<any>{
    return apiTravel.post("/cliente-imagem/inserir", data).then((resp) =>  resp.data).catch(e => {
      AlertNotify({message: 'Ocorreu um erro ao salvar o arquivo!', type:'warning'})
      return Promise.reject(e);
    });
  }